module.exports = __webpack_public_path__ + "static/john-w-bb981a1ab0eaf99cfc9d7ad635b525bc.png";